import React, { FC } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { i18n } from '../../../../../symphony';
import { ILPWhySololearnData } from '../../../../../api/private/learn-engine-api/landing-page-api.interface';

import s from './WhySololearn.scss';

type Props = {
	data: ILPWhySololearnData;
	alias: string;
};

export const WhySololearn: FC<Props> = ({ data, alias }) => {
	useStyles(s);
	return (
		<div className="why-sololearn">
			<div className="why-sololearn__container">
				<h4 className="why-sololearn__title">
					{i18n.t(`web-lelp.${alias}-why-sololearn-title`)}
				</h4>
				<p
					className="why-sololearn__description"
					dangerouslySetInnerHTML={{
						__html: i18n.t(
							`web-lelp.${alias}-why-sololearn-description`,
						),
					}}
				/>
				<div className="why-sololearn__items-container">
					{data.items.map((item, index) => (
						<div className="why-sololearn__item" key={item.imgUrl}>
							<img
								className="why-sololearn__image"
								src={item.imgUrl}
								alt=""
							/>
							<span className="why-sololearn__item-title">
								{i18n.t(
									`web-lelp.${alias}-why-sololearn-item${index}-title`,
								)}
							</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
